import { CustomObject } from '../types/data';
import last from 'lodash/last';

export const getSpotType = (imageSrc: string) => {
  const name = last(String(imageSrc).split('/'));

  switch (name) {
    case 'helicopter2.png':
    case 'helicopter.png':
      return 'helicopter';
    case 'ground.png':
      return 'ground';
    default:
      return 'default';
  }
};

export const getSpaceType = (spaceData: CustomObject) => {
  if (spaceData.box || spaceData.isPhoto) {
    return 'photo';
  } else if (spaceData.video_urls) {
    return 'video';
  }

  return 'unknown';
};

export const getNumberSign = ($n: number) => {
  const sign = Number($n > 0) - Number($n < 0);
  return sign === 0 ? 1 : sign;
};

export const numberToShow = (x: number | string) => {
  return (x < 10 ? `0${x}` : x).toString();
};

export const splitTextToPages = (text: string, maxRowCount: number = 4, maxSymbolCountInRow: number = 25) => {
  text = text.replace(/\t/gu, '    ');
  text = text.replace(/\s+/gu, ' ');

  text = text.replace(/(\\r\\n|\\n|\\r)/gu, '\n');
  const tmpRows = text.split('\n');

  const rows: string[] = [];

  tmpRows.forEach(row => {
    const size = ~~maxSymbolCountInRow;
    const chunks = size > 0 ? row.match(new RegExp(`(.|\\s){1,${size}}(\\b|\\W)`, 'gu')) : [row];

    if (chunks) {
      rows.push(...chunks);
    }
  });

  const pages: string[] = [];

  while (true) {
    if (!rows.length) {
      break;
    }

    pages.push(rows.splice(0, maxRowCount).join('\n'));
  }

  return pages;
};

export const assignParametersToNativeEvent = (mainEvents: CustomObject, nativeEvents: string[], params: any[]) => {
  let events = {
    ...mainEvents,
  };

  nativeEvents.forEach(evtName => {
    if (mainEvents.hasOwnProperty(evtName)) {
      events[evtName] = (state: CustomObject, ...args: any[]) => {
        state.args = params;
        mainEvents[evtName].apply(mainEvents, [state, ...args]);
      };
    }
  });

  return events;
};

/// slide generation code

type TParagraphs = string[][];

const generateRows = (paragraphs: TParagraphs, count: number = 1, symbolsCount: number = 50) => {
  const rows = [];
  let p = paragraphs.shift();

  for (let i = 0; i < count; i++) {
    if (!p || !p.length) {
      if (!paragraphs.length) {
        break;
      }

      p = paragraphs.shift() as string[];
    }

    let row = '';

    while (p[0] !== undefined && (row + p[0] + ' ').length <= symbolsCount) {
      row += p.shift() + ' ';
    }

    rows.push(row.trim());
  }

  if (p && p.length) {
    paragraphs.unshift(p);
  }

  return {
    paragraphs,
    data: rows,
  };
};

const cleanText = (text: string) => {
  text = text.replace(/(\r\n|\r|\n)+/gu, '\n');
  text = text.replace(/(\t| {2,})+/gu, ' ');

  return text;
};

export const splitTextBySlides = (text: string, rowCount: number, symbolsCount: number, count: number = Infinity) => {
  text = cleanText(text);
  const slides: any[] = [];
  let paragraphs: any[] = [];

  if (text.length) {
    paragraphs = text.split('\n').map(p => p.trim().split(' '));

    for (let i = 0; i < count; i++) {
      if (!paragraphs.length) {
        break;
      }
      const payload = generateRows(paragraphs, rowCount, symbolsCount);
      paragraphs = payload.paragraphs;
      slides.push(payload.data);
    }
  }

  return { slides, paragraphs };
};
